import { ModelSnapshot } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptClass,
  isModelConceptRelationship,
} from 'src/containers/ProjectDiagram/utils/data';
import { ModelSizes, isLargeModelSize } from 'src/utils/checkImportModelLimits';

/**
 * Class/property counts for a diagram model snapshot: classes from the
 * model-concept nodes, properties from datatype attributes + distinct
 * relationship IRIs.
 */
export const getDiagramSnapshotSizes = (
  snapshot: ModelSnapshot | null | undefined
): ModelSizes => {
  if (!snapshot) {
    return { classes: 0, properties: 0 };
  }

  const { nodeDataArray, linkDataArray, modelData } = snapshot;

  const totalAttributes = Object.keys(modelData.attributesByIri).length;
  const totalRelationships = new Set(
    linkDataArray
      .filter(isModelConceptRelationship)
      .map((linkData) => linkData.value)
  ).size;

  return {
    classes: nodeDataArray.filter(isModelConceptClass).length,
    properties: totalAttributes + totalRelationships,
  };
};

/**
 * Whether a diagram model is large enough that building the GoJS visual tree
 * would OOM the tab or hang the main thread for minutes in which
 * case we defer the diagram and default to the headless list view
 */
export const isLargeDiagramSnapshot = (
  snapshot: ModelSnapshot | null | undefined
): boolean => isLargeModelSize(getDiagramSnapshotSizes(snapshot));
